let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("a5EaQ")).then(() => parcelRequire('iMYa9'));